import { useEffect, useState } from "react";
import Typewriter from "typewriter-effect";
import Header from "../components/header";
import { SignupModelHelper } from "../data/SignupModel";
import { AmplitudeService } from '../services/AmplitudeService';
import { UserService } from '../services/UserService';

export default function MeuCurriculo(props: any) {

  const [typed, setTyped] = useState(false);

  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    // TagManager.dataLayer(dataLayerHelper.pagina('cadastrado', 'meu-curriculo'));
    AmplitudeService.track('Register Congratulations Screen')
  }, [])

  function getFirstName() {
    const firstName = UserService.getLoggedUser().name.split(' ')[0];
    return firstName;
  }

  return (
    <>
      <Header step={ 1 } total={ 1 } title="Meu Currículo" previous="#/carta-apresentacao"></Header>

      <div className="chat-container">

        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter
                          .changeDelay(15)
                          .typeString(`Parabéns ${getFirstName()}, seu currículo já está pronto para ser utilizado! <br><br>Você pode baixá-lo para impressão ou compartilhamento.`)
                          .callFunction(() => {
                            setTyped(true);
                          })
                          .start();
                      } }
                    />
                  </div>
                </div>

                { typed &&
                  <div className="option-list">
                    <a className="btn btn-outline btn-full" rel='noopener noreferrer' href={ process.env.REACT_APP_CANDIDATE_APP_URL! + '/meu-curriculo' }
                      onClick={ () => {

                        AmplitudeService.track('Acess/Download CV Clicked')
                      } }>Acessar/baixar currículo</a>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>);
}
